import React from 'react';
export const BonusesSection = () => {
  const bonuses = [{
    num: '01',
    icon: '🍎',
    title: 'Vital Nutrition 60+',
    subtitle: 'Senior-Friendly Recipes and Weekly Meal Plan',
    desc: '30 pages of simple, affordable recipes adapted for the most common senior health conditions. Heart-healthy options suitable for diabetes and high blood pressure. With everyday grocery store ingredients. Includes complete weekly meal plan and ready-to-use healthy shopping list.',
    price: '$19 USD'
  }, {
    num: '02',
    icon: '👥',
    title: 'Family Connection Kit',
    subtitle: 'Reminiscence Cards and Meaningful Family Activities',
    desc: '30 pages of social connection activities for older adults. Life-stage conversation cards, group activities, no-equipment games and the Intergenerational Recipe Book project. To reduce isolation and reconnect with grandchildren and family.',
    price: '$17 USD'
  }, {
    num: '03',
    icon: '🏠',
    title: 'Safe Home Checklist',
    subtitle: 'Room-by-Room Fall and Accident Prevention Audit',
    desc: '30 pages of step-by-step home safety audit. Bathroom, bedroom, kitchen, hallways, stairs, lighting and exterior. 142 verification items with priority improvement action plan. Most home falls can be prevented with simple, affordable adaptations.',
    price: '$15 USD'
  }];
  return <section className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-19">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-20">
        <div className="text-center mb-10 md:mb-16" data-id="element-21">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-22">
            🎁 PLUS 3 EXCLUSIVE BONUSES
          </h2>
          <p className="text-familia-gray text-[15px] md:text-lg" data-id="element-23">
            Always included — no extra cost
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-10 md:mb-16" data-id="element-24">
          {bonuses.map((b, i) => <div key={i} className="bg-familia-card border border-familia-gold/25 p-6 md:p-8 rounded-2xl relative flex flex-col" data-id="element-25">
              <div className="absolute -top-3 left-6 md:left-8 bg-familia-gold text-familia-bg font-bold text-xs py-1 px-3 rounded" data-id="element-26">
                BONUS {b.num}
              </div>
              <div className="text-4xl md:text-5xl mb-4 md:mb-6 mt-2" data-id="element-27">
                {b.icon}
              </div>
              <h3 className="text-lg md:text-xl font-display font-bold mb-1" data-id="element-28">
                {b.title}
              </h3>
              <p className="text-familia-gold text-xs sm:text-sm font-semibold mb-3" data-id="element-29">
                {b.subtitle}
              </p>
              <p className="text-familia-gray text-[14px] md:text-sm leading-relaxed mb-6 md:mb-8 flex-grow" data-id="element-30">
                {b.desc}
              </p>
              <div className="flex items-center justify-between pt-4 md:pt-6 border-t border-white/10" data-id="element-31">
                <span className="text-familia-red line-through text-sm" data-id="element-32">
                  Regular Value: {b.price}
                </span>
                <span className="text-familia-green font-bold" data-id="element-33">
                  INCLUDED FREE ✅
                </span>
              </div>
            </div>)}
        </div>
        <div className="bg-familia-bg border-2 border-familia-gold rounded-2xl p-6 md:p-8 text-center max-w-md mx-auto" data-id="element-34">
          <p className="text-familia-gray text-sm mb-2" data-id="element-35">Total Bonus Value</p>
          <p className="text-familia-red text-2xl md:text-3xl font-display font-bold line-through mb-3 md:mb-4" data-id="element-36">
            $51 USD
          </p>
          <div className="bg-familia-gold text-familia-bg font-bold py-3 px-6 rounded-xl mb-3 md:mb-4 text-base md:text-lg" data-id="element-37">
            🎁 INCLUDED FREE WITH YOUR PURCHASE TODAY
          </div>
          <p className="text-familia-gray text-xs" data-id="element-38">
            With every Master Kit purchase.
          </p>
        </div>
      </div>
    </section>;
};